export default __webpack_public_path__ + "static/media/semi.0583207a.svg";